export default "__VITE_ASSET__2de13f7e__"